import mediaCreate from "./mediaCreate";
import mediaList from "./mediaList";
import { PermMediaRounded,AddAPhoto } from "@mui/icons-material";

const Media = {
  list: mediaList,
  create: mediaCreate,
  icon: PermMediaRounded,
  createIcon: AddAPhoto,
};
export default Media;